export default "__VITE_ASSET__BfZsLG_e__"